import { INITIAL_STATE } from '../../constants';

function newUser() {
	const newUserState = {
		...INITIAL_STATE,
	};

	window.localStorage.setItem('tabbyCatVersion1', true);
	return newUserState;
}

export default newUser;



// WEBPACK FOOTER //
// ./src/utils/getStorage/newUser.js